titles:
  createAppointment: Maak een afspraak
  contact: Contactgegevens
  openingHours: Openingstijden
descriptions:
  chooseAppointment: Kies een behandeling en plan je afspraak online. Het duurt maar een paar minuten.
actions:
  createAppointment: Afspraak maken
